const generateIstockImageSrc = (id) => `/ws/getty-images/${id}.jpg`;

const generateAlternativeIstockBgImageSrc = (id) => `/ws/alt-imgs/orig/${id}.webp`;

export { generateIstockImageSrc, generateAlternativeIstockBgImageSrc };
